export const state = {
  history: [],
  isLoading: true,
  overlayVisible: false,
};
